import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    loading: false,
    created: null,
    finished: null,
    id: null,
    cuId: null,
    error: null,
    paymentMethodAdded: false,
    bundleData: null,
    bundlePurchaseSuccess: false,
    paymentIntent: null

};

const createTransactionsRequest = () => {
    return {
        created: null,
        error: null,
        loading: true,
    }
};

const createTransactionsSuccess = ( state, action ) => {
    return {
        created: action.data,
        error: null,
        loading: false,
    }
};

const createTransactionsFail = ( state, action ) => {
    return {
        created: null,
        error: action.error,
        loading: false,
    }
};

const runTransactionsRequest = () => {
    return {
        finished: null,
        error: null,
        loading: true,
    }
};

const runTransactionsSuccess = ( state, action ) => {
    return {
        finished: action.data,
        error: null,
        loading: false,
    }
};

const runTransactionsFail = ( state, action ) => {
    return {
        finished: null,
        error: action.error,
        loading: false,
    }
};


const createPaymentIntentStart = (state, action) => {
    console.log('create intent start');
    return updateState(state, {
        loading: true,
        error: null,
        paymentIntent: null
    });
};

const createPaymentIntentSuccess = (state, action) => {
    console.log('create intent succ');
    return updateState(state, {
        loading: false,
        error: null,
        paymentIntent: action.data.clientSecret
    });
};

const createPaymentIntentError = (state, action) => {
    console.log('create intent error');
    return updateState(state, {
        loading: false,
        error: action.error
    });
};


const addPaymentMethodRequest = () => {
    return {
        paymentMethodAdded: false,
        error: null,
        loading: true,
    }
};

const addPaymentMethodSuccess = (state, action) => {
    return {
        paymentMethodAdded: true,
        error: null,
        loading: false,
        finished: action.data
    }
};

const addPaymentMethodFail = ( state, action ) => {
    return {
        paymentMethodAdded: false,
        error: action.error,
        loading: false,
    }
};

const clearTransactionsErrors = () => {
    return {
        error: null
    }
};

const clearTransactions = () => {
    return {
        finished: null
    }
};

const getUserIdRequest = (state, action) => {
    return {
        loading: true
    }
};

const getUserIdSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        id: action.id,
        cuId: action.cuId
    }
};

const getUserIdError = (state, action) => {
    return {
        error: action.error
    }
};

const resetUserIdAndCuId = (state, action) => {
    return updateState(state, {
        id: null,
        cuId: null
    })
};

const runBundleRequest = (state, action) => {
    return updateState(state, {
        loading: true
    })
};

const runBundleSuccess = (state, action) => {
    return updateState(state, {
        bundlePurchaseSuccess: true,
        loading: false
    })
};

const runBundleError = (state, action) => {
    return updateState(state, {
        error: action.error
    })
};

export const transactionsReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.CREATE_TRANSACTIONS_REQUEST: return createTransactionsRequest();
        case actionTypes.CREATE_TRANSACTIONS_SUCCESS: return createTransactionsSuccess(state, action);
        case actionTypes.CREATE_TRANSACTIONS_FAIL: return createTransactionsFail(state, action);
        case actionTypes.RUN_TRANSACTIONS_REQUEST: return runTransactionsRequest();
        case actionTypes.RUN_TRANSACTIONS_SUCCESS: return runTransactionsSuccess(state, action);
        case actionTypes.RUN_TRANSACTIONS_FAIL: return runTransactionsFail(state, action);
        case actionTypes.ADD_PAYMENT_METHOD_REQUEST: return addPaymentMethodRequest();
        case actionTypes.ADD_PAYMENT_METHOD_SUCCESS: return addPaymentMethodSuccess(state, action);
        case actionTypes.ADD_PAYMENT_METHOD_FAIL: return addPaymentMethodFail(state, action);
        case actionTypes.CLEAR_ALL_ERRORS: return clearTransactionsErrors();
        case actionTypes.CLEAR_TRANSACTIONS: return clearTransactions();
        case actionTypes.GET_USER_ID_FROM_CUID_REQUEST: return getUserIdRequest(state, action);
        case actionTypes.GET_USER_ID_FROM_CUID_SUCCESS: return getUserIdSuccess(state, action);
        case actionTypes.GET_USER_ID_FROM_CUID_ERROR: return getUserIdError(state, action);
        case actionTypes.RESET_USER_ID_AND_CUID: return resetUserIdAndCuId(state, action);
        case actionTypes.RUN_BUNDLE_REQUEST: return runBundleRequest(state, action);
        case actionTypes.RUN_BUNDLE_SUCCESS: return runBundleSuccess(state, action);
        case actionTypes.RUN_BUNDLE_ERROR: return runBundleError(state, action);
        case actionTypes.CREATE_PAYMENT_INTENT_START: return createPaymentIntentStart(state, action);
        case actionTypes.CREATE_PAYMENT_INTENT_SUCCESS: return createPaymentIntentSuccess(state, action);
        case actionTypes.CREATE_PAYMENT_INTENT_ERROR: return createPaymentIntentError(state, action);
        default:
            return state;
    }
};
